import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

/**
 * /api/pos-receipt-templates — how a merchant's POS prints the customer receipt (Epson).
 * Reads fall back to null; writes return the saved payload or null after a toast with the
 * server's reason (a refused layout comes back as one message listing every problem).
 */

const messageOf = (error, fallback) => error?.response?.data?.message ?? error?.message ?? fallback;

const read = async (call, message) => {
  try {
    const res = await call();
    if (res?.data && !res.data.isError) return res.data.data ?? null;
    errorToast(res?.data?.message ?? message);
    return null;
  } catch (error) {
    errorToast(messageOf(error, message));
    return null;
  }
};

const write = async (call, message) => {
  try {
    const res = await call();
    if (res?.data && !res.data.isError) return { data: res.data.data, message: res.data.message };
    errorToast(res?.data?.message ?? message);
    return null;
  } catch (error) {
    errorToast(messageOf(error, message));
    return null;
  }
};

const withMerchant = (merchantId) => (merchantId && merchantId !== "all" ? { merchantId } : {});

export const listPosReceiptTemplates = (merchantId) =>
  read(() => axiosInstance.get("/api/pos-receipt-templates", { params: withMerchant(merchantId) }), "Error loading receipt templates");

export const getPosReceiptTemplate = (id) =>
  read(() => axiosInstance.get(`/api/pos-receipt-templates/${id}`), "Error loading the receipt template");

export const createPosReceiptTemplate = ({ merchantId, name, layout, basedOnTemplateId }) =>
  write(() => axiosInstance.post("/api/pos-receipt-templates", { ...withMerchant(merchantId), name, layout, basedOnTemplateId }), "Error creating the template");

export const duplicatePosReceiptTemplate = (id, { merchantId, name } = {}) =>
  write(() => axiosInstance.post(`/api/pos-receipt-templates/${id}/duplicate`, { ...withMerchant(merchantId), ...(name ? { name } : {}) }), "Error cloning the template");

export const updatePosReceiptTemplate = (id, { name, layout }) =>
  write(() => axiosInstance.put(`/api/pos-receipt-templates/${id}`, { ...(name !== undefined ? { name } : {}), ...(layout !== undefined ? { layout } : {}) }), "Error saving the template");

export const deletePosReceiptTemplate = (id) =>
  write(() => axiosInstance.delete(`/api/pos-receipt-templates/${id}`), "Error deleting the template");

export const activatePosReceiptTemplate = (id, merchantId) =>
  write(() => axiosInstance.post(`/api/pos-receipt-templates/${id}/activate`, withMerchant(merchantId)), "Error activating the template");
